import {currentHostName} from "./StageConfig";
import {ENV_STAGES} from "./constants/ApiConstants";
import {
    BUGSNAG_API_KEY,
    BUGSNAG_ENVIRONMENT,
    BUGSNAG_NOTIFY_ENDPOINT, BUGSNAG_SESSION_ENDPOINT,
    BUGSNAG_TRACE_ENDPOINT
} from "./constants/BugSnagConstants";
import BugsnagPerformance from "@bugsnag/browser-performance";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import Bugsnag from "@bugsnag/js";

export const startBugsnag = () => {
    if (currentHostName === ENV_STAGES.BETA || currentHostName === ENV_STAGES.PROD) {
        Bugsnag.start({
            apiKey: BUGSNAG_API_KEY[BUGSNAG_ENVIRONMENT[currentHostName]],
            appVersion: '1.0.1',
            plugins: [new BugsnagPluginReact()],

            endpoints: {
                "notify": BUGSNAG_NOTIFY_ENDPOINT[BUGSNAG_ENVIRONMENT[currentHostName]],
                "sessions": BUGSNAG_SESSION_ENDPOINT[BUGSNAG_ENVIRONMENT[currentHostName]]
            }
        });
        BugsnagPerformance.start({
            apiKey: BUGSNAG_API_KEY[BUGSNAG_ENVIRONMENT[currentHostName]],
            appVersion: '1.0.1',
            endpoint: BUGSNAG_TRACE_ENDPOINT[BUGSNAG_ENVIRONMENT[currentHostName]]
        });
    }
}

export const notify = (error: any) => {
    if (currentHostName === ENV_STAGES.BETA || currentHostName === ENV_STAGES.PROD) {
        Bugsnag.notify(error);
    }
}